"use client";

import { createContext, useEffect, useMemo } from "react";
import { DirectionProvider } from "@radix-ui/react-direction";
import { useLanguage } from "@/hooks/useLanguage";
import { USER_LANGUAGES } from "@/config/enums/user.enum";

export const RtlContext = createContext({
  dir: "ltr",
  isRtl: false,
});

export function RtlProvider({ children }) {
  const currentLang = useLanguage();
  const isRtl = currentLang === USER_LANGUAGES.ARABIC; //!
  const dir = isRtl ? "rtl" : "ltr";

  useEffect(() => {
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute(
      "lang",
      currentLang || USER_LANGUAGES.ENGLISH, //!
    );
  }, [dir, currentLang]);

  const value = useMemo(
    () => ({
      dir,
      isRtl,
    }),
    [dir, isRtl],
  );

  return (
    <RtlContext.Provider value={value}>
      <DirectionProvider dir={dir}>{children}</DirectionProvider>
    </RtlContext.Provider>
  );
}
